import '../styles.css';

function Footer() {
  return (
    <footer style={{
      backgroundColor: '#f8f9fa',
      borderTop: '1px solid #e9ecef',
      padding: '20px 0',
      marginTop: 'auto',
      textAlign: 'center'
    }}>
      <div className="container" style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
        <div style={{ display: 'flex', justifyContent: 'center', gap: '30px', marginBottom: '15px' }}>
          <a 
            href="/help"
            style={{
              color: '#6c757d',
              textDecoration: 'none',
              fontSize: '14px'
            }}
            onMouseOver={(e) => e.target.style.color = '#007bff'}
            onMouseOut={(e) => e.target.style.color = '#6c757d'}
          >
            Help & Support
          </a>
          <a 
            href="/contact"
            style={{
              color: '#6c757d',
              textDecoration: 'none',
              fontSize: '14px'
            }}
            onMouseOver={(e) => e.target.style.color = '#007bff'}
            onMouseOut={(e) => e.target.style.color = '#6c757d'}
          >
            Contact Us
          </a>
        </div>
        <div style={{ color: '#6c757d', fontSize: '12px' }}>
          © 2025 True Devotion. All rights reserved.
        </div>
      </div>
    </footer>
  );
}

export default Footer;
